import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import ShopLayout from "../Layout";
import GetShopBanksList from "../../Profile/Bankdetails/index";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import BreadCrumb from "../../Layouts/Breadcrumb";

const ShopBanksList = (): ReactElement => {
  const route = useParams();
  return (
    <React.Fragment>
      <BreadCrumb  
        shopId={(route as any)?.shopId}
        title="Bank List "
        subTitle="Bank List"
        extra={<></>}
      />
        <div className="content-body_ rounded-2xl">
          <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-0 mb-6">
            <GetShopBanksList
              inShop={true}
              getShopId={(route as any)?.shopId}
            />
          </div>
        </div>
    </React.Fragment>
  );
};

ShopBanksList.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default ShopBanksList;
